import React, { useEffect, useRef, useState } from 'react';
import './TooltipIcon.sass';

import { ReactComponent as OpenIcon } from '../../../assets/img/tooltips/open.svg';
import { ReactComponent as CloseIcon } from '../../../assets/img/tooltips/close.svg';

interface Props {
	tooltipValue: string;
	setActive?: any;
	active?: boolean;
	// id: string;
}

function TooltipIcon({ tooltipValue, setActive, active }: Props) {
	const handleClick = () => {
		setActive(!active);
	};

	const tooltipRef = useRef<HTMLDivElement>(null);
	const makeTooltipActive = (value: string, show: boolean) => {
		const tooltip = document.querySelector(`[data-id="${value}"]`);
		if (tooltip) {
			if (show) {
				tooltip.classList.add('tooltip--active');
			} else {
				tooltip.classList.remove('tooltip--active');
			}
		}
	};
	/* @ts-ignore */
	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (tooltipRef && tooltipRef.current) {
			tooltipRef.current.addEventListener(
				'click',
				/* @ts-ignore */
				makeTooltipActive(tooltipValue, active)
			);
			return () => {
				if (tooltipRef && tooltipRef.current) {
					/* @ts-ignore */
					tooltipRef.current.removeEventListener('click', makeTooltipActive);
				}
			};
		}
	}, [active]);
	return (
		<span
			ref={tooltipRef}
			className={`form-label__tooltip${
				active ? ' form-label__tooltip--active' : ''
			}`}
			role="button"
			tabIndex={0}
			onClick={() => handleClick()}
			onKeyDown={() => handleClick()}
		>
			<OpenIcon />
			<CloseIcon />
		</span>
	);
}

export default TooltipIcon;
